import {Component, Inject, OnInit} from '@angular/core';

import {Observable} from 'rxjs/Observable';
import {NavigationCategory, User} from "../infrastructure/models";
import {AuthService, LocalizationService2, UserService} from "../infrastructure/services";
import {Router} from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {
  private LOGO = this.baseUrl + '/Static/img/logo.png';
  isLoggedIn$: Observable<boolean>;

  currentUser: Observable<User>;
  private lblNavbarMerchant = this.localization.getLabelByKey('lblNavbarMerchant');

  private door_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarDoor'), 'doors', this.baseUrl + '/Static/icons/42.svg');
  private vordach_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarVordach'), 'vordach', this.baseUrl + '/Static/icons/43.svg');
  private presentation_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarPresentation'), 'presentation', this.baseUrl + '/Static/icons/25.svg');
  private offer_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarOffer'), 'offers', this.baseUrl + '/Static/icons/44.svg');
  private customer_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarCustomer'), 'customers', this.baseUrl + '/Static/icons/03.svg');
  private settings_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarSettings'), 'settings/general', this.baseUrl + '/Static/icons/45.svg');
  private merchant_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblNavbarMerchant'), 'redirect' , this.baseUrl + '/Static/icons/55.svg', 'https://www.kompotherm.de/login');
  private fernwartung_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblFernwarung'), 'redirect', this.baseUrl + '/Static/icons/55.svg', this.baseUrl + '/api/fernwartung/');
  private home_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblHome'), 'home', this.baseUrl + '/Static/icons/02.svg');
  private impressum_nav_item = new NavigationCategory(this.localization
    .getLabelByKey('lblImpressum'), 'impressum', this.baseUrl + '/Static/icons/02.svg');
  private first_group = [
    this.door_nav_item,
    this.vordach_nav_item,
    this.presentation_nav_item,
    this.offer_nav_item
  ];
  private second_group = [
    this.home_nav_item,
    this.customer_nav_item,
    this.settings_nav_item
  ];
  private first_hamburger_group = [
    this.home_nav_item,
    this.customer_nav_item
  ];
  private second_hamburger_group = [
    this.merchant_nav_item,
    this.settings_nav_item,
    this.impressum_nav_item,
    this.fernwartung_nav_item
  ];

  private navbarFirstGroupItems = this.first_group;
  private navbarSecondGroup = this.second_group;
  private firstHamburgerGroup = this.first_hamburger_group;
  private secondHamburgerGroup = this.second_hamburger_group;

  private _authService: AuthService;
  private _userService: UserService;
  private _router: Router;

  constructor(@Inject('BASE_URL') private baseUrl: string, private localization: LocalizationService2, authService: AuthService, userService: UserService, router: Router) {

    this._authService = authService;
    this._userService = userService;
    this._router = router;
  }

  ngOnInit(): void {
      this.isLoggedIn$ = this._authService.isAuth;
      this.currentUser = this._userService.getCurrentUser();
  }
  private navigateTo(navigationCategory : NavigationCategory):string{
    if(navigationCategory.routeParameter === null){
      this._router.navigate([navigationCategory.link]);
      return;
    }
    this._router.navigate([navigationCategory.link+ '/' + navigationCategory.routeParameter]);
    return;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/header/header.component.ts